import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Components/Home";
import Manuals from "./Components/Manuals";
// import StudentManual from "./Components/StudentManual";
// import NotFound from "./Components/NotFound";

function App() {
  return (
    <Router>
      <div className="sdc-root">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/manuals" element={<Manuals />} />
          {/* <Route path="/student-manual" element={<StudentManual />} /> */}

          {/* 404 */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;